import { axios } from '@/utils/request'

export default{
  getAll(input){
    return axios.get('/api/services/app/WxUser/GetAll',{params:input})
  }
}